/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { vappContainer, VApplication } from '../../../../../application';
import { ApplicationFormPageService } from '@/pages/ApplicationForm/services';
import { toast } from 'react-hot-toast';

const MODULE_NAME = 'newApplication.machines.states.getPage';

const getSrv = () => {
  return vappContainer.get<ApplicationFormPageService>(
    ApplicationFormPageService.displayName
  );
};

export const ResubmitApplicant = async (context: any, event: any) => {
  console.log(`in ersubmitapp state :`, event);
  // toast.success('came in state');
  return new Promise(async (resolve, reject) => {
    try {
      console.log(MODULE_NAME, 'context: ', context, 'event: ', event);
      const src = getSrv();

      const data: any = await src.agent.resubmitApplicant(event?.payload);
      console.log(`payload in newApplication ::::`, event?.payload, data);
      console.log('loding statte...');
      if (data?.reSubmitApplicationByApplicant) {
        // toast.success(context['RESUBMIT_APPLICATION_BY_APPLICANT_SUCCESS'].message);
        console.log('succews statte...');
        return resolve({
          key: 'RESUBMIT_APPLICATION_BY_APPLICANT_SUCCESS',
          value: {
            ...(data || {}),
          },
        });
      } else {
        console.log('failure statte...');
        // toast.error(context['CREATE_APPLICATION_ERROR']?.message);
        return reject({
          key: 'RESUBMIT_APPLICATION_BY_APPLICANT_ERROR',
          value: 'Failed to resubmit application',
        });
      }
    } catch (err: any) {
      // toast.error(context['CREATE_APPLICATION_ERROR']?.message);
      return reject({
        key: 'CREATE_APPLICATION_ERROR',
        value: err?.message,
      });
    }
  });
};
